import { render, staticRenderFns } from "./ohif-viewer.vue?vue&type=template&id=5c4af084&scoped=true"
import script from "./ohif-viewer.vue?vue&type=script&lang=js"
export * from "./ohif-viewer.vue?vue&type=script&lang=js"
import style0 from "./ohif-viewer.vue?vue&type=style&index=0&id=5c4af084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4af084",
  null
  
)

export default component.exports